// extracted by mini-css-extract-plugin
export var hideEditor = "_m6-2";
export var infoIcon = "_m6-3";
export var label = "_m6-1";
export var labelContainer = "_m6-0";
export var readonlyText = "_m6-4";